/* ManageDeviceViewRenderer.js */

"use strict";
const _ = require("lodash");
const EntityGrid = require("@gluenetworks/entity_grid_gl").Grid;
const ButtonControl = require("@gluenetworks/steve_ui_core").Control.Action.Button;

class ManageDeviceViewRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("manage-device-view-gl");
        this._rootElem.component = this._model;
        this._targets = {};

        this._addButtonIcon = document.createElement("base-icon-gl");
        this._addButtonIcon.setAttribute("class", "btn-icon-right");
        this._addButtonIcon.dataset.icon = "common.back";

        this._removeButtonIcon = document.createElement("base-icon-gl");
        this._removeButtonIcon.setAttribute("class", "btn-icon-left");
        this._removeButtonIcon.dataset.icon = "common.back";

        this._removeAllButtonIcon = document.createElement("base-icon-gl");
        this._removeAllButtonIcon.setAttribute("class", "btn-icon-left");
        this._removeAllButtonIcon.dataset.icon = "common.back";

        this._addButton = new ButtonControl({label: "<span>Add</span>"});
        this._addButton._renderer._rootElem.appendChild(this._addButtonIcon);

        this._removeButton = new ButtonControl({label: "<span>Remove</span>"});
        this._removeButton._renderer._rootElem.prepend(this._removeButtonIcon);

        this._removeAllButton = new ButtonControl({label: "<span>Remove All</span>"});
        this._removeAllButton._renderer._rootElem.prepend(this._removeAllButtonIcon);
        this._availGridContainer = document.createElement("avail-grid-container");
        this._selGridContainer = document.createElement("sel-grid-container");
        this._selControlContainer = document.createElement("sel-control-container");
        this._availFilterComponent = document.createElement("game-editor-header-gl");
        this._availFilterComponent.classList.add("ge-header");
        this._selectFilterComponent = document.createElement("game-editor-header-gl");
        this._selectFilterComponent.classList.add("select-ge-header");
        this._prevSelectedIDs = [];
        this._availFilterHeader = this._generateElement(
            "span",
            "ge-header-text",
            "Available Devices"
        );
        this._selectFilterHeader = this._generateElement(
            "span",
            "ge-header-text",
            "Selected Devices"
        );

        this._registerListeners();
        this._registerViewAction();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    /**
     * Generate
     */
    _generateElement(name, className, text) {
        const el = document.createElement(name);
        el.classList.add(className);
        el.innerText = text;
        return el;
    }

    _registerListeners() {
        this._model.on("Shutdown", (this._onShutdown = this._onShutdown.bind(this)));
        this._model.on(
            "PagingFeedChange",
            (this._onPagingFeedChange = this._onPagingFeedChange.bind(this))
        );
        this._addButton.on(
            "UserClick",
            (this._onAddButtonClick = this._onAddButtonClick.bind(this))
        );
        this._removeButton.on(
            "UserClick",
            (this._onRemoveButtonClick = this._onRemoveButtonClick.bind(this))
        );
        this._removeAllButton.on(
            "UserClick",
            (this._onRemoveAllButtonClick = this._onRemoveAllButtonClick.bind(this))
        );
    }

    _unregisterListeners() {
        this._model.removeListener("Shutdown", this._onShutdown);
        this._model.removeListener("PagingFeedChange", this._onPagingFeedChange);
        this._addButton.removeListener("UserClick", this._onAddButtonClick);
        this._removeButton.removeListener("UserClick", this._onRemoveButtonClick);
        this._removeAllButton.removeListener("UserClick", this._onRemoveAllButtonClick);
    }

    _registerAvailGridListeners() {
        this._availableTargetsGrid.on(
            "UserSelectedRows",
            (this._onAvailGridUserSelectedRows = this._onAvailGridUserSelectedRows.bind(this))
        );
        this._availableTargetsGrid.on(
            "UserRowDoubleClicked",
            (this._onAvailGridUserRowDoubleClicked =
                this._onAvailGridUserRowDoubleClicked.bind(this))
        );
        this._availableTargetsGrid.on(
            "BasicSearchFilterChangeData",
            (this._onUserSelectFilter = this._onUserSelectFilter.bind(this))
        );
    }

    _unregisterAvailGridListeners() {
        this._availableTargetsGrid.removeListener(
            "UserSelectedRows",
            this._onAvailGridUserSelectedRows
        );
        this._availableTargetsGrid.removeListener(
            "UserRowDoubleClicked",
            this._onAvailGridUserRowDoubleClicked
        );
        this._availableTargetsGrid.removeListener(
            "AdvancedSearchFilterChangeData",
            this._onUserSelectFilter
        );
    }

    _registerSelGridListeners() {
        this._selectedTargetsGrid.on(
            "UserSelectedRows",
            (this._onSelGridUserSelectedRows = this._onSelGridUserSelectedRows.bind(this))
        );
        this._selectedTargetsGrid.on(
            "UserRowDoubleClicked",
            (this._onSelGridUserRowDoubleClicked = this._onSelGridUserRowDoubleClicked.bind(this))
        );
    }

    _unregisterSelGridListeners() {
        this._selectedTargetsGrid.removeListener(
            "UserSelectedRows",
            this._onSelGridUserSelectedRows
        );
        this._selectedTargetsGrid.removeListener(
            "UserRowDoubleClicked",
            this._onSelGridUserRowDoubleClicked
        );
    }

    _registerViewAction() {
        this.model.gameEditor.addViewAction({
            type: "normal",
            displayName: "Save",
            name: "SavePlanDevice",
            handler: (this._onPlanDeviceSave = this._onPlanDeviceSave.bind(this)),
        });
        this.model.gameEditor.addViewAction({
            type: "normal",
            displayName: "Cancel",
            name: "CancelPlanDevice",
            handler: (this._onPlanDeviceCancel = this._onPlanDeviceCancel.bind(this)),
        });
    }
    _hideViewAction() {
        this.model.gameEditor.hideViewAction("SavePlanDevice");
        this.model.gameEditor.hideViewAction("CancelPlanDevice");
    }
    _disableViewActions() {
        this.model.gameEditor.disableViewAction("SavePlanDevice");
        this.model.gameEditor.disableViewAction("CancelPlanDevice");
    }

    _enableViewActions() {
        this.model.gameEditor.enableViewAction("SavePlanDevice");
        this.model.gameEditor.enableViewAction("CancelPlanDevice");
    }
    _removeViewActions() {
        this.model.gameEditor.removeViewAction("SavePlanDevice");
        this.model.gameEditor.removeViewAction("CancelPlanDevice");
    }
    _toggleAction(isDirty) {
        if (isDirty || this._model._planDetails.isCompleted) {
            this._disableViewActions();
        } else {
            this._enableViewActions();
        }
    }
    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    render() {
        if (!this._rootElem.hasChildNodes()) {
            this._rootElem.appendChild(this._availGridContainer);
            this._rootElem.appendChild(this._selControlContainer);
            this._rootElem.appendChild(this._selGridContainer);
        }
        return Promise.resolve()
            .then(() => {
                return this._model.whenModelIsReady();
            })
            .then(() => {
                this._renderAvailGrid();
                this._renderSelControls();
                this._renderSelGrid();
            })
            .then(() => {
                this._initTargets(this._model.selectedIDs);
                this._toggleAction(this._model.isDirty);
            });
    }
    get rootElement() {
        return this.getRootElement();
    }
    getRootElement() {
        return this._rootElem;
    }
    get model() {
        return this.getModel();
    }
    getModel() {
        return this._model;
    }

    get selectedRows() {
        return this._availableTargetsGrid.getSelectedRows();
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START PRIVATE RENDER METHODS */
    /*******************************************/

    _renderSelControls() {
        this._selControlContainer.innerHTML = "";

        return Promise.resolve().then(() => {
            this._selControlContainer.appendChild(this._addButton.renderer.rootElement);
            this._selControlContainer.appendChild(this._removeButton.renderer.rootElement);
            this._selControlContainer.appendChild(this._removeAllButton.renderer.rootElement);
            this._addButton.renderer.rootElement.classList.add("target-button");
            this._removeButton.renderer.rootElement.classList.add("target-button");
            this._removeAllButton.renderer.rootElement.classList.add("target-button");
        });
    }

    _renderSelGrid() {
        this._removeButton.disabled = true;
        this._removeAllButton.disabled = true;

        this._selGridContainer.innerHTML = "";
        if (this._selectedTargetsGrid) {
            this._unregisterSelGridListeners();
            this._selectedTargetsGrid.shutdown();
        }
        this._selectedTargetsGrid = new EntityGrid({
            singleSelect: false,
            columns: this._model.selColumnConfig,
            pagingFeed: this._model.selectedTargetsPagingFeed,
            showHeader: true,
            gridKey: `${this._model._gridKey}_selected`,
            showLinesNumber: true,
            useUserDataStorage: false,
        });
        this._selGridContainer.appendChild(this._selectFilterComponent);
        this._selGridContainer.appendChild(this._selectedTargetsGrid.renderer.rootElement);
        this._selectFilterComponent.appendChild(this._selectFilterHeader);
        this._registerSelGridListeners();
    }

    _renderAvailGrid() {
        this._addButton.disabled = true;
        this._availGridContainer.innerHTML = "";
        this._availableTargetsGrid = new EntityGrid({
            singleSelect: false,
            columns: this._model.availColumnConfig,
            pagingFeed: this._model.availableTargetsPagingFeed,
            showHeader: true,
            gridKey: `${this._model._gridKey}_available`,
            showLinesNumber: true,
            useUserDataStorage: false,
            filterComponent: this._availFilterComponent,
        });
        this._availGridContainer.appendChild(this._availFilterComponent);
        this._availGridContainer.appendChild(this._availableTargetsGrid.renderer.rootElement);
        this._availFilterComponent.appendChild(this._availFilterHeader);
        this._registerAvailGridListeners();
    }

    /*******************************************/
    /* END PRIVATE RENDER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    _onPagingFeedChange() {
        this._renderAvailGrid();
    }

    _onAvailGridUserSelectedRows(e) {
        this._addButton.disabled = this._checkDisabled(e.selectedRows.length === 0);
    }

    _onAvailGridUserRowDoubleClicked(e) {
        if (!this._checkDisabled(false)) {
            this._addToTargets([e.selectedRow]);
        }
    }
    _onUserSelectFilter() {
        let filterQuery = this._availableTargetsGrid._filterQuery;
        this._model._availableDevicesPagingFeed._deviceAvilaFeedReestablish(filterQuery);
    }
    _onAddButtonClick() {
        this._addToTargets(this._availableTargetsGrid.getSelectedRows());
    }

    _onSelGridUserSelectedRows(e) {
        this._removeButton.disabled = this._checkDisabled(e.selectedRows.length === 0);
    }

    _onSelGridUserRowDoubleClicked(e) {
        if (!this._checkDisabled(false)) {
            this._removeFromTargets([e.selectedRow]);
        }
    }

    _onRemoveButtonClick() {
        this._removeFromTargets(this._selectedTargetsGrid.getSelectedRows());
    }

    _onRemoveAllButtonClick() {
        let ids = Object.keys(this._targets);
        this._model.availableTargetsPagingFeed.removeAllIds();
        this._model.selectedTargetsPagingFeed.removeAllIds();
        this._availableTargetsGrid.setSelectedRows(ids);
        this._selectedTargetsGrid.setSelectedRows(null);
        this._addButton.disabled = this._checkDisabled(false);
        this._removeButton.disabled = true;
        this._removeAllButton.disabled = true;
        this._removeIdsFromModel(ids);
    }

    _onShutdown() {
        // The grids only exist once render() has got past whenModelIsReady(), so a
        // failed open tears down a partially built view.
        let shutdowns = [
            this._availableTargetsGrid ? this._availableTargetsGrid.shutdown() : undefined,
            this._addButton.shutdown(),
            this._removeButton.shutdown(),
            this._removeAllButton.shutdown(),
            this._selectedTargetsGrid ? this._selectedTargetsGrid.shutdown() : undefined,
        ];
        return Promise.all(shutdowns)
            .then(() => {
                this._unregisterListeners();
                if (this._availableTargetsGrid) {
                    this._unregisterAvailGridListeners();
                }
                if (this._selectedTargetsGrid) {
                    this._unregisterSelGridListeners();
                }
                this._removeViewActions();
                this._model = undefined;
                this._rootElem.remove();
                this._rootElem = undefined;
                this._availGridContainer.remove();
                this._availGridContainer = undefined;
                this._selControlContainer.remove();
                this._selControlContainer = undefined;
                this._selGridContainer.remove();
                this._selGridContainer = undefined;
                this._addButton = undefined;
                this._removeButton = undefined;
                this._selectedTargetsGrid = undefined;
                this._availableTargetsGrid = undefined;
                this._availFilterComponent = undefined;
                this._selectFilterComponent = undefined;
            })
            .catch((err) => {
                console.error(err);
            });
    }

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/

    _initTargets(ids = []) {
        this._prevSelectedIDs = [];
        this._targets = {};
        ids.forEach((id) => {
            this._targets[id] = true;
            this._prevSelectedIDs.push(id);
        });
        this._addToTargets(ids, true);
    }

    _addToTargets(ids, skipModelUpdate) {
        this._model.availableTargetsPagingFeed.addIds(ids);
        this._model.selectedTargetsPagingFeed.addIds(ids);

        this._selectedTargetsGrid.setSelectedRows(ids);
        this._availableTargetsGrid.setSelectedRows(null);
        if (!skipModelUpdate) {
            this._addIdsToModel(ids);
        }
        this._addButton.disabled = true;
        this._removeButton.disabled = this._checkDisabled(false);
        this._removeAllButton.disabled = this._checkDisabled(_.isEmpty(this._targets));
        this._checkDirtyGrid();
    }

    _addIdsToModel(ids) {
        ids.forEach((id) => {
            this._targets[id] = true;
        });
        this._model._addDevices(ids);
    }

    _removeFromTargets(ids) {
        this._model.availableTargetsPagingFeed.removeIds(ids);
        this._model.selectedTargetsPagingFeed.removeIds(ids);

        this._availableTargetsGrid.setSelectedRows(ids);
        this._selectedTargetsGrid.setSelectedRows(null);
        this._removeIdsFromModel(ids);

        this._addButton.disabled = this._checkDisabled(false);
        this._removeButton.disabled = this._checkDisabled(_.isEmpty(this._targets));
        this._removeAllButton.disabled = this._checkDisabled(_.isEmpty(this._targets));
    }

    _removeIdsFromModel(ids) {
        ids.forEach((id) => {
            delete this._targets[id];
        });
        this._model._removeDevices(ids);
        this._checkDirtyGrid();
    }

    _checkDisabled(isDisabled) {
        return !!isDisabled;
    }

    _onPlanDeviceSave() {
        this._disableViewActions();
        return this._model
            ._saveDevice()
            .then(() => {
                this._prevSelectedIDs = this._model.selectedIDs;
                this._model.isDirty = false;
                this._disableViewActions();
            })
            .catch((err) => {
                console.warn(err);
            });
    }

    _onPlanDeviceCancel() {
        this.model.gameEditor.runQuickConfirmationActionWorkflow(
            {
                message: "Are you sure you want to cancel? All changes will be lost.",
                title: "Cancel Confirmation",
                confirmDetails: {
                    text: "Yes",
                    type: "destructive",
                },
            },
            (this._onPlanDeviceCancelAction = this._onPlanDeviceCancelAction.bind(this))
        );
    }
    _onPlanDeviceCancelAction() {
        this._model.selectedIDs = this._prevSelectedIDs;
        this._model.availableTargetsPagingFeed.removeAllIds();
        this._model.selectedTargetsPagingFeed.removeAllIds();
        this._model.availableTargetsPagingFeed.addIds(this._prevSelectedIDs);
        this._model.selectedTargetsPagingFeed.addIds(this._prevSelectedIDs);
        this._model._discardDeviceChanges();
        this._model.isDirty = false;
        // this.render();
        this._toggleAction(true);
    }
    _checkDirtyGrid() {
        let target = Object.keys(this._targets);
        let prevData = this._prevSelectedIDs;
        this._model.selectedIDs = target;
        if (target.length !== prevData.length) {
            this._model.isDirty = true;
            this._toggleAction(false);
        } else if (
            _.difference(target, prevData).length > 0 ||
            _.difference(prevData, target).length > 0
        ) {
            this._model.isDirty = true;
            this._toggleAction(false);
        } else {
            this._model.isDirty = false;
            if (_.isNull(this._model._plan._pendingPatches)) {
                this._model._gameEditor.getTabCmpnt().setDirty(false);
            }
            this._toggleAction(true);
        }
    }
    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}

module.exports = ManageDeviceViewRenderer;
